/***********************************************************************************************************************
 *
 * V2.0
 *
 * User: tomers
 * Date: 9/10/13
 * Visual PDF: https://docs.google.com/a/liveperson.com/file/d/0B7O_LAPhjkbkRzJ4ME81LXEwNm8
 *
 * Options:
 * container - mandatory. jQuery element. The element on the page where the component will be created in.
 * tagName - optional. String. an HTML tag name to render the component in this element. "div" is default.
 * name - optional. String. A name for this instance of dropdown. "value" is the default.
 * customItem - optional. Object. an Item to add to the collection, at the top. Usefull for a collection use with a collection map.
 * {
 *      key: "",
 *      value: "",
 *      [icon: "",]
 *      [cssClass: "",]
 * }
 * items - optional. Preferred to be an instance of Dropdown.Collection (DropdownItemsCollection). Can be any Backbone.Collection but there the property "collectionMap" is mandatory. Empty collection is the default.
 * collectionMap - optional. if the items is not instance of Dropdown.Collection its mandatory. Object. Should be a map to use when converting from the items to the Dropdown.Collection.
 *  should be in the following structure:
 *  {
 *      key: "THE_ATTRIBUTE_NAME_IN_items_COLLECTION_THAT_REPRESENTS_THE_ITEM_KEY",
 *      value: "THE_ATTRIBUTE_NAME_IN_items_COLLECTION_THAT_REPRESENTS_THE_ITEM_VALUE",
 *      [icon: "THE_ATTRIBUTE_NAME_IN_items_COLLECTION_THAT_REPRESENTS_THE_ITEM_ICON",]
 *      [cssClass: "THE_ATTRIBUTE_NAME_IN_items_COLLECTION_THAT_REPRESENTS_THE_ITEM_CSS_CLASS"]
 *  }
 * listenToCollectionChanges - optional. Boolean. true - The dropdown binds listeners to changes in the original collection and updates itself automatically with the changes.
 * selectedOption - optional. The key of the initialized selected option. If there is no selecteOption in the options object and there is no placeholder - the first item of Items is selected
 * enabled - optional. Boolean. Detects if the dropdown is enabled and clickable or not. TRUE is default.
 * permutation - optional. Responsible for the dropdown button style. One of the options in the static Dropdown.PERMUTATION enum. Dropdown.PERMUTATION.DEFAULT is the default.
 * listPermutation - optional. Responsible for dropdown list style. One of the options in the static Dropdown.LIST_PERMUTATION enum. Dropdown.LIST_PERMUTATION.DEFAULT is the default.
 * buttonLabel - optional. Responsible for what to show in the dropdown button for the selected option. text/icon/both. One of the options in the static Dropdown.BUTTON_LABEL enum. Dropdown.BUTTON_LABEL.TEXT is the default.
 * showLabel - optional. Boolean. TRUE - when the user is not hover over the dropdown wrapper we show only a label with the selected option and not the button. FALSE - we always show the button. FALSE is the default.
 * tabindex - optional. Number. The tabindex to attach to the dropdown button.
 * autofocus - optional. Boolean. TRUE - to attach to the dropdown button the html attribute "autofocus". FALSE is the default.
 * placeholder - optional. String. The string to show on the button or the label when there is no selected option.
 * testCollision - optional. Boolean. Whether or not to use the ability to detect if the list is out of the boundaries of the collisionWithinSelector and the change its locations. FALSE is the default.
 * collisionWithinSelector - optional. String. The selector to use when we test the collision. "window" is the default.
 * ellipsis - optional. If true, enables ellipsis feature
 * ignoreMaxWidth - optional. If true, reset the max width css rule from the dropdown options list

 * ********************************************************************************************************************/
/***********************************************************************************************************************
 *                                                                                                                     *
 * V1.0                                                                                                                *
 *                                                                                                                     *
 * User: Adi Baron                                                                                                     *
 * Date: 8/5/13                                                                                                        *
 * Visual PDF:                                                                                                         *
 *      https://docs.google.com/a/liveperson.com/file/d/0B7O_LAPhjkbkRzJ4ME81LXEwNm8                                   *
 *                                                                                                                     *
 * ********************************************************************************************************************/

define(function (require) {

    "use strict";

    /////////////////////////////////////////////////////////////////////////////
    //                              Dependencies                               //
    /////////////////////////////////////////////////////////////////////////////
    var $ = require("jquery");
    var _ = require("underscore");
    var Marionette = require("marionette");
    var Bubble = require("ui/bubble/Bubble");
    var template = require("ui/dropdown/templates/dropdown.tmpl");
    var DropdownItemModel = require("ui/dropdown/js/models/DropdownItemModel");
    var DropdownModel = require("ui/dropdown/js/models/DropdownModel");
    var DropdownItemView = require("ui/dropdown/js/views/DropdownItemView");
    var DropdownItemsCollection = require("ui/dropdown/js/collections/DropdownItemsCollection");
    var SearchController = require("ui/dropdown/js/controllers/SearchController");
    var Tooltip = require("ui/tooltip/Tooltip");

    require("jqueryui/position");
    require("ui.plugins/jquery.ba-outside-events");

    var KeyCode = {
        ESC:27,
        ENTER:13,
        ARROW_UP:38,
        ARROW_DOWN:40
    };
    var CONST_DROPDOWN_MENU_HEIGHT_BUFFER = 10;
    var CONST_DROPDOWN_MAX_ITEMS_SHOWN_IN_MENU = 10;
    var CONST_DROPDOWN_NUMPAD_KEYCODE_MIN = 96;
    var CONST_DROPDOWN_NUMPAD_KEYCODE_MAX = 105;
    var CONST_DROPDOWN_NUMPAD_KEYCODE_DELTA = 48;
    var CONST_DROPDOWN_MENU_IGNORE_MAX_WIDTH_CLASS = "ignore-max-width";

    var Dropdown = Marionette.CompositeView.extend({
        template:template,
        errorMsg:null,
        withUIComponents:true,
        itemView:DropdownItemView,
        itemViewContainer:".menu",
        events:{
            "mouseenter .dropdown":"_handleWrapperMouseEnter",
            "mouseleave .dropdown":"_handleWrapperMouseLeave",
            "click .dropdown button":"_handleButtonClick",
            "mouseenter .dropdown button":"_handleButtonMouseEnter",
            "mouseleave .dropdown button":"_handleButtonMouseLeave",
            "keydown .dropdown button":"_handleButtonKeyDown",
            "clickoutside":"_handleOutsideClick"
        },
        modelEvents:{
            "change:enabled":"_renderEnabled",
            "change:selectedOption":"_onSelectedOptionChanged",
            "change:activeOption":"_onActiveOptionChanged"
        },
        itemEventsDeprecated:{
            "itemview:itemMouseOver":"_handleItemMouseOver",
            "itemview:itemClick":"_handleItemClick"
        },
        ui:{
            wrapper:".dropdown",
            label:".dropdown .dropdown-selected-label",
            menu:".dropdown .menu",
            button:".dropdown button"
        },
        customTemplateHelpers:function () {
            return {
                showLabel:this.showLabel,
                tabindex:this.tabindex,
                autofocus:this.autofocus
            };
        },
        itemViewOptions: function(model, index) {
            return {
                itemIndex: index
            };
        },
        initialize:function (options) {
            // make sure options is a valid object.
            if (!options || !_.isPlainObject(options)) {
                throw "Dropdown: invalid argument: options is illegal.";
            }

            // Extend with initializers
            _.extend(this, initializers);

            this.setViewMembersValues(options);
            this.setViewModel(options);
            this.animateRequsetCounter = 0;

            this.collection = this.model.get("items");
            if (this.model.hasSelectedOption() && this.collection.where({"key":this.model.get("selectedOption")}).length === 0) {
                throw "Dropdown >> initialize >> selectedOption must point to an existing value in the item list. selected option=" + this.model.get("selectedOption");
            }

            this.searchController = new SearchController({
                collection:this.collection
            });
            Marionette.bindEntityEvents(this, this, this.itemEventsDeprecated);
        },

        onRender:function () {
            //everytime the dropdown is rendered we need to initialize these properties especially when the setItems is used to re-render the dropdown
            this.displayedItemsReversed = false;
            this.isUpwards = false;

            if (!_.isNull(this.container)) {
                this.container.append(this.$el);
            }
            this._renderEnabled();
            this._showSelectedOptionInButton();
            this._updateTooltip();
            this.ui.wrapper.addClass(this.permutation);
            this.ui.menu.addClass(this.listPermutation);
            this.ui.button.addClass(this.buttonLabel);
            if (this.showLabel) {
                this.ui.label.addClass(this.buttonLabel);
            }
            if (this.ignoreMaxWidth) {
                this.ui.menu.addClass(CONST_DROPDOWN_MENU_IGNORE_MAX_WIDTH_CLASS);
            }
        },

        /**
         * According to differentiation between browsers we should calculate the max height of list with js code.
         * The max height should be 10 items of 1 line + buffer (both the number of items and the buffer is set with constants)
         * @private
         */
        _getListMaxHeight: function() {
            var maxHeight = this.maxItemsToShow * this._getMenuItemHeight() + CONST_DROPDOWN_MENU_HEIGHT_BUFFER;
            return maxHeight;
        },

        /**
         * In order to make sure we calculate the height of only one line of item we set the value of the item to be one character so it's sure the item is only one line
         * @return {Number}
         * @private
         */
        _getMenuItemHeight: function() {
            var oneCharacterForTesting = "a";
            var menuItemHeight = 0;
            var numOfItems = this.model.get("items").size();
            if (numOfItems > 0) {
                var middleChildrenView = this.children.findByIndex(parseInt(numOfItems / 2, 10));
                var originalValue = middleChildrenView.model.get("value");
                this.ui.menu.addClass("special-hide-for-height-calculation"); // we are using display:block and visibility:hidden for calculate the height of element that is hidden
                middleChildrenView.model.set("value", oneCharacterForTesting);
                menuItemHeight = middleChildrenView.$el.outerHeight(true);
                middleChildrenView.model.set("value", originalValue);
                this.ui.menu.removeClass("special-hide-for-height-calculation");
            }

            return menuItemHeight;
        },

        /**
         * Set the items from outside.
         * In case of there is no selectedOption when the user set items, and there is no placeholder, we should select the first option
         * Also, We should re-init the menuMaxHeight attribute because after set new items the max-height can be a different value
         * @param items - collection of items. should be instance of DropdownItemsCollection or any other collection with a collection conversion map
         * @param collectionMap - relevant only if the collection is not instance of DropdownItemsCollection so we need to convert it to this by this map
         * @options pass model options - currently supports selectedOption
         * */
        setItems:function (items, collectionMap,options) {
            this.model.set("items", this._getItemsReady(items, collectionMap));
            if (options && _.has(options,"selectedOption")){
                this.model.set({"selectedOption": options.selectedOption}, {silent:true});
            }
            if (!this.model.hasSelectedOption() && _.isNull(this.placeholder) && this.model.get("items").size() > 0 ) {
                this.model.set({"selectedOption": this.model.get("items").at(0).get("key")}, {silent:true});
            }
            this.collection = this.model.get("items");
            this.menuMaxHeight = null;
            this.render();
        },

        /**
         * Get the items ready for use.
         * If its not instance of the Dropdown Items Collection we should convert it with the collection map the user should provide
         *
         * @param items - the items that sent by the user in the "options" object
         * @param collectionMap - map to convert by from the items instanceof to the DropdownCollection
         * @return {*} - the items, ready for use by mustache and model
         */
        _getItemsReady:function (collection, collectionMap) {
            var readyItemsArr = [];

            if (!_.isEmpty(this.customItem)) {
                readyItemsArr.push(this.customItem);
            }

            if (collection instanceof DropdownItemsCollection) {
                readyItemsArr = readyItemsArr.concat(collection.models);
            }
            else {
                var mappedCollection = convertToDropdownCollection(collection, collectionMap);
                readyItemsArr = readyItemsArr.concat(mappedCollection.models);
            }

            var readyCollection = new DropdownItemsCollection(readyItemsArr);

            if (this.listenToCollectionChanges) {
                this._bindEventsToOriginalCollection(collection);
            }

            return readyCollection;
        },


        /**
         * We need to bind each model separately because when we update a model, an "add" trigger is not fired on the collection and only on the model
         * We are listening to the change event on the relevant specific attributes according to the collectionMap
         * @param collection
         * @private
         */
        _bindEventsToOriginalCollection: function(collection) {
            this.listenTo(collection, "add", this._addModelToCollection);
            this.listenTo(collection, "remove", this._removeModelFromCollection);

            _.each(collection.models, _.bind(function(model) {
                this._bindEventsToModel(model);
            }, this));
        },
        _bindEventsToModel: function(model) {
            var valueAttrName = getAttributeName("value", this.collectionMap);
            var iconAttrName = getAttributeName("icon", this.collectionMap);
            var cssClassAttrName = getAttributeName("cssClass", this.collectionMap);

            this.listenTo(model, "change:"+valueAttrName, this._updateModelInCollection);
            this.listenTo(model, "change:"+iconAttrName, this._updateModelInCollection);
            this.listenTo(model, "change:"+cssClassAttrName, this._updateModelInCollection);
        },

        _addModelToCollection: function(model) {
            this._bindEventsToModel(model);
            var convertedModel = convertToDropdownItemModel(model, this.collectionMap);

            /*
            * Fix bug LE-82578
            * If add element to exists dropdown when is open up with collection reversed, new item will be rendered at last and change location of additional(+Add ...) item.
            * We reverse reversed list before adding new item.
            * */
            if(this.displayedItemsReversed) {
                this._reverseDisplayedItems();
            }
            this.model.get("items").add(convertedModel.toJSON(), {merge:true});
        },

        /**
         * If existing model has changed - update its attributes on the drodpdown and if this is the selected item - update the "button"
         * @param model
         * @private
         */
        _updateModelInCollection: function(model) {
            var convertedModel = convertToDropdownItemModel(model, this.collectionMap);
            var existingModel = this._getItemModelByKey(convertedModel.get("key"));

            if (!_.isEmpty(existingModel)) {
                existingModel.set("value", convertedModel.get("value"));
                existingModel.set("icon", convertedModel.get("icon"));
                existingModel.set("cssClass", convertedModel.get("cssClass"));

                if (this.model.get("selectedOption") === existingModel.get("key")) {
                    this._showSelectedOptionInButton();
                }
            }
        },

        _removeModelFromCollection: function(model) {
            var deletedModelKey = getAttributeFromModel("key", model, this.collectionMap);
            var deletedModelFromCollection = this._getItemModelByKey(deletedModelKey);
            this.model.get("items").remove(deletedModelFromCollection);

            if (this.model.get("selectedOption") === deletedModelKey) {
                if (!_.isNull(this.placeholder)) {
                    this._setSelection(null);
                }
                else {
                    this._setSelection(this.model.get("items").at(0).get("key"));
                }

            }
        },

        setTooltip: function(tooltip, align, position) {
            this.tooltip = tooltip;
            this.tooltipAlign = align;
            this.tooltipPosition = position;
            this._updateTooltip();
        },

        _updateTooltip: function() {
            this.ui.button.attr("title", this.tooltip);
            // tooltip-text (following line) is a patch for an exception in which the tooltip is kept opened while modification is done
            this.ui.button.attr("tooltip-text", this.tooltip);
            if (!_.isUndefined(this.tooltipAlign)) {
                this.ui.button.attr("tooltip-align", this.tooltipAlign);
            }
            if (!_.isUndefined(this.tooltipPosition)) {
                this.ui.button.attr("tooltip-position", this.tooltipPosition);
            }
        },

        /**
         * set the state of the dropdown to enabled/disabled
         * @param enabled {true / false} For dropdown enabled - true, otherwise - false.
         */
        setEnabled:function (enabled) {
            this.model.set("enabled", enabled);
        },

        /**
         * @return {true / false} -  For dropdown enabled - true, otherwise - false.
         */
        isEnabled:function () {
            return this.model.get("enabled");
        },

        _renderEnabled:function () {
            var enabled = this.model.get("enabled");
            this.ui.wrapper.toggleClass("disabled", !enabled);
            this.ui.button.prop("disabled", !enabled);
        },

        /**
         * set dropdown selection - should be used only from outside
         * @param key
         * @param options  allow selecting in silent mode using {silent: true }  default is silent
         */
        setSelection:function (key, options) {
            options = options || {};
            options.silent = _.has(options, "silent") ? options.silent : true;
            this._setSelection(key, options);
        },

        /**
         * set the dropdown selection - publish an event if silent (via options) is not in use
         * @param key
         * @param options - allow selecting in silent mode using {silent: true }
         * @private
         */
        _setSelection:function (key, options) {
            options = options || {};

            // check that item with this key is exist
            if (_.isEmpty(this._getItemModelByKey(key)) && !_.isNull(key)) {
                return;
            }

            var oldKey = this.model.get("selectedOption");
            var oldItemModel = (!_.isEmpty(oldKey) || _.isNumber(oldKey)) ? this._getItemModelByKey(oldKey) : null; // we check for Number because integer is considered as empty in _.isEmpty
            var oldValue = oldItemModel ? oldItemModel.get("value") : null; //need to make sure that the old item was not removed from the collection
            var newKey = key;
            var newValue = (!_.isEmpty(newKey) || _.isNumber(newKey)) ? this._getItemModelByKey(newKey).get("value") : null; // we check for Number because integer is considered as empty in _.isEmpty

            this.model.set("selectedOption", newKey);

            var selectionContext = {
                oldKey:oldKey,
                oldValue:oldValue,
                selectedKey:newKey,
                selectedValue:newValue
            };

            if (!options.silent) {
                this.trigger(Dropdown.TRIGGERING.CHANGE, selectionContext);
            }
        },

        _onSelectedOptionChanged:function () {
            this._showSelectedOptionInList();
            this._showSelectedOptionInButton();
        },

        _onActiveOptionChanged:function () {
            this._showActiveOptionInList();
        },

        /**
         * Show the selectedOption in the button and in the label if we have to.
         * Appends to the button container the text/icon/both according to the buttonLabel property.
         * Also, appends it also to the label container, according to showLabel property
         *
         * @private
         */
        _showSelectedOptionInButton:function () {
            if (this.model.hasSelectedOption()) {
                var selectedKey = this.model.get("selectedOption");
                var selectedValue = this._getItemModelByKey(selectedKey).get("value");
                var selectedIcon = this._getItemModelByKey(selectedKey).get("icon");
                var selectedItemView = this._getItemViewByKey(selectedKey);
                var selectedItemViewHtml;

                this.ui.button.html("");
                this.ui.label.html("");
                if (this.buttonLabel === Dropdown.BUTTON_LABEL.ICON_TEXT || this.buttonLabel === Dropdown.BUTTON_LABEL.ICON) {
                    selectedItemView.getIconHTMLElement().appendTo(this.ui.button);
                    if (this.showLabel) {
                        selectedItemView.getIconHTMLElement().appendTo(this.ui.label);
                    }
                }
                else if (this.buttonLabel === Dropdown.BUTTON_LABEL.ICON_TEXT || this.buttonLabel === Dropdown.BUTTON_LABEL.TEXT) {
                    selectedItemViewHtml = selectedItemView.getValueHTMLElement();
                    if (this.ellipsis) {
                        selectedItemViewHtml.addClass("ellipsis");
                    }
                    selectedItemViewHtml.appendTo(this.ui.button);
                    if (this.showLabel) {
                        selectedItemView.getValueHTMLElement().appendTo(this.ui.label);
                    }
                }
                this.ui.button.attr("data-key", selectedKey);
                this.ui.button.attr("data-value", selectedValue);
                this.ui.button.attr("data-icon", selectedIcon);
            }
            else if (!_.isNull(this.placeholder)) {
                this.ui.button.text(this.placeholder);
            }
        },

        /**
         * Shows the selectedOption within the items list.
         * Calls the setSelected on the itemView to mark the itemView as selected
         *
         * @private
         */
        _showSelectedOptionInList:function () {
            var oldSelectedOption = this.model.previous("selectedOption");
            var oldSelectedItemView = this._getItemViewByKey(oldSelectedOption);
            if (!_.isEmpty(oldSelectedItemView)) {
                oldSelectedItemView.setSelected(false);
            }

            if (this.model.hasSelectedOption()) {
                var newSelectedOption = this.model.get("selectedOption");
                var newSelectedItemView = this._getItemViewByKey(newSelectedOption);
                newSelectedItemView.setSelected(true);
            }
        },

        /**
         * Shows the activeOption in the items list.
         * Calls the setActive on the itemView to mark the itemView as active
         *
         * @private
         */
        _showActiveOptionInList:function () {
            var oldActiveOption = this.model.previous("activeOption");
            var oldActiveItemView = this._getItemViewByKey(oldActiveOption);
            if (!_.isEmpty(oldActiveItemView)) {
                oldActiveItemView.setActive(false);
            }

            if (this.model.hasActiveOption()) {
                var newActiveOption = this.model.get("activeOption");
                var newActiveItemView = this._getItemViewByKey(newActiveOption);
                if (!_.isNull(newActiveItemView)){
                    newActiveItemView.setActive(true);
                }
            }
        },

        /**
         * Hides the items list (and closes the error indication if there is).
         * If the user set the showLabel property to true and the button is not hovered - we show the label when we hide the list.
         */
        hideItemsList:function () {
            if (this.uiComponents && this.uiComponents.DropdownError) {
                this.setError(false);
            }

            $(this.ui.menu).removeClass("show"); // In this specific case the ui.menu is still the selector and not the element itself so we need to wrap it with jQuery.
            this.isListOpen = false;
            if (this.showLabel && !this.ui.button.data("hover")) {
                this._showDropdownLabel();
            }
            this.searchController.reset();
        },

        /**
         * Shows the items list.
         * Set the activeOption to be the selectedOption
         * According to differentiation between browsers we should calculate the max height of list with js code.
         *
         * The max height should be 10 items of 1 line + buffer (both the number of items and the buffer is set with constants).
         * This is done here (only once) because we must be sure that the items is on the dom and we can calculate the max-height
         *
         * NOTE: jqueryui.position is not being used for collision detection due to 2 issues:
         * 1. There is a bug in the collision detection in some case, see http://bugs.jqueryui.com/ticket/8710
         * 2. jqueryui.position requires the element to be in the DOM before the positioning, this create issues with scrolling and sizing of the container div.
         * view.ui.menu.position({
         *   my : "left top",
         *   at : "left bottom",
         *   of : view.ui.button,
         *   collision: "flip",
         *   using: _.bind(view.adjustPosition, view),
         *   within: ".le .cmp"
         *   });
         */
        showItemsList:function () {
            if (_.isNull(this.menuMaxHeight)) {
                this.menuMaxHeight = this._getListMaxHeight();
                this.ui.menu.css("max-height", this.menuMaxHeight+"px");
            }

            if (this.listPermutation === Dropdown.LIST_PERMUTATION.BUBBLE_LIST) {
                this._showItemsBubbleList();
            }
            else {
                this._showItemsDefaultList();
            }

            this.isListOpen = true;
            this._showSelectedOptionInList();

            // if the activeOption is already the selectedOption we need to make sure we show it as active as well as selected. otherwise - we should set is as active
            if (this.model.get("activeOption") === this.model.get("selectedOption")) {
                this._showActiveOptionInList();
            }
            else {
                this.model.set("activeOption", this.model.get("selectedOption"));
            }

            if (this.ui.button.hasClass("error") && this.errorMsg) {
                this.uiComponents.host$.createAndRender("DropdownError", {
                    type:Bubble,
                    options:{
                        targetControl:this.ui.button,
                        text:this.errorMsg,
                        position:this.errorPosition,
                        icon:Bubble.ICON.ERROR,
                        showCloseButton:false
                    }
                });
            }
            this._setScroll();
            var activeOptionKey = this.model.get("activeOption");
            this._scrollToActiveItem(null, activeOptionKey);
        },

        _showItemsBubbleList:function () {
            if (this.testCollision) {
                if (this._shouldOpenListUpwards()) {
                    // Render upwards
                    this._adjustListPosition({"top":"auto", "left":"auto"}, {"vertical":"bottom"}); // We are calling adjustPosition before the show to position the list in the correct vertical position
                    this.ui.menu.addClass("show");
                    this._adjustListPosition({"top":"auto", "left":this._getBubbleListLeftPosition()}, {"vertical":"bottom"}); // We are calling adjustPosition second time because only when the list is shown we know the correct horizontal position
                }
                else {
                    // Render downwards
                    this._adjustListPosition({"top":"auto", "left":"auto"}, {"vertical":"top"}); // We are calling adjustPosition before the show to position the list in the correct vertical position
                    this.ui.menu.addClass("show");
                    this._adjustListPosition({"top":"auto", "left":this._getBubbleListLeftPosition()}, {"vertical":"top"}); // We are calling adjustPosition second time because only when the list is shown we know the correct horizontal position
                }
            }
            else {
                this.ui.menu.addClass("show");
                this._adjustListPosition({"top":"auto", "left":this._getBubbleListLeftPosition()}, {"vertical":"top"});
            }
        },

        _showItemsDefaultList:function () {
            if (this.testCollision) {
                // First test for collision, then move the list close to the final position, and finally use
                // jqueryui.position to accurately position the list above the button
                if (this._shouldOpenListUpwards()) {
                    // Render upwards
                    this.ui.menu.addClass("show");
                    this.ui.menu.position({
                        my:"left bottom",
                        at:"left top",
                        of:this.ui.button,
                        using:_.bind(this._adjustListPosition, this)
                    });
                }
                else {
                    // Render downwards
                    this._adjustListPosition({"top":"auto", "left":"auto"}, {"vertical":"top"});
                    this.ui.menu.addClass("show");
                }
            }
            else {
                this.ui.menu.addClass("show");
            }
        },

        _setScroll:function(){
            var infinite = -10000;

            if(this.ui.menu.css("top").indexOf("-") === 0){
                infinite *= -1;
            }
            this.ui.menu.animate({scrollTop:this.ui.menu.scrollTop() + infinite}, 0);
        },

        /***
         * adjustPosition: get the coordinates generated by the jqueryui position. sets the position accordingly
         * @param coordinates: calculated coordinates
         * @param feedback: other details regarding the position of the menu
         */
        _adjustListPosition:function (coordinates, feedback) {
            // The dropdown may open upwards so we have to reverse the items display order
            // Here we make sure that the actual order of the items fits the displayedItemsReversed state
            if ((feedback.vertical === "bottom" && !this.displayedItemsReversed) || // upwards -> reverse
                (feedback.vertical === "top" && this.displayedItemsReversed)) {       // downwards -> not reversed
                this._reverseDisplayedItems(); // reverse the list elements
            }

            // Update the flag to indicate the dropdown is opened upwards
            this.isUpwards = feedback.vertical === "bottom";

            var top = coordinates.top;
            var left = coordinates.left;
            this.ui.menu.css({"top":top, "left":left});
            this.ui.menu.toggleClass("list-position-top", this.isUpwards);
            this.ui.menu.toggleClass("list-position-bottom", !this.isUpwards);
        },

        /***
         * _reverseDisplayedItems: reverse the order of the list items and updates the displayedItemsReversed state
         * @private
         */
        _reverseDisplayedItems:function () {
            var ul = this.ui.menu;
            ul.children().each(function (i, li) {
                ul.prepend(li);
            });
            this.displayedItemsReversed = !this.displayedItemsReversed;
        },

        /**
         * Decides whether to render the list upwards or downwards. First the dropdown is tested for collision with the bottom of the container as defined by the
         * collisionWithinSelector option. If no collision, render downwards. In case of collision, test for collision with the top of the container. If colliding
         * with top, render downwards.
         * @returns {boolean} true if the menu should open upwards.
         */
        _shouldOpenListUpwards: function() {
            this.ui.menu.addClass("special-hide-for-height-calculation"); // we are using display:block and visibility:hidden for calculate the height of element that is hidden
            var buttonOffsetY = this.ui.button.offset().top;
            var buttonHeight = this.ui.button.outerHeight(true); // calculate the height includes the border, padding and margin. the "true" is for calculating also the margin
            var listHeight = this.ui.menu.outerHeight(true);
            this.ui.menu.removeClass("special-hide-for-height-calculation");

            // Test collision with bottom
            var listBottomY = buttonOffsetY + buttonHeight + listHeight; // the bottom y coordinate of the list when it is opened downwards
            // If collisionWithinSelector is not window, use minimum of window and collisionWithinSelector bottom Y value
            var boundaryBottomY = this.collisionWithinSelector === "window" ? window.innerHeight :
                _.min([$(this.collisionWithinSelector).offset().top + $(this.collisionWithinSelector).height(), window.innerHeight]);
            if(listBottomY <= boundaryBottomY) { // no collision with bottom
                return false; // render downwards
            }

            // Test collision with top when rendered upwards
            var listTopY = buttonOffsetY - listHeight; // the top y coordinate of the list when it is opened upwards
            var boundaryTopY = this.collisionWithinSelector === "window" ? 0 :
                _.max([$(this.collisionWithinSelector).offset().top, 0]);
            if(listTopY >= boundaryTopY) { // no collision with top
                return true; // render upwards
            } else { // collision with top
                return false; // render downwards
            }
        },

        /**
         * center the menu list if the list permutation is BUBBLE_LIST and we should center the list according to the button
         * this code was taken from DropdownMenu component
         * Return the "left" position of the list. The "top" should be calculated and set by the collision detection code
         */
        _getBubbleListLeftPosition:function () {
            var extraPerm = 1.5;
            if ((this.ui.button.width() / 2) < 10) {
                extraPerm += 10 - (this.ui.button.width() / 2);
            }
            var left = (this.ui.button.position().left + getElementTotalWidth(this.ui.button) / 2) - getElementTotalWidth(this.ui.menu) / 2 + extraPerm;
            return left;
        },

        /**
         * Shows the dropdown button instead of the label - relevant only if there is switch between button and label
         * @private
         */
        _showDropdownButton:function () {
            if (this.showLabel) {
                this.ui.label.removeClass("show-inline");
                this.ui.button.addClass("show-inline");
            }
        },

        /**
         * Shows the dropdown label instead of the button - relevant only if there is switch between button and label
         * @private
         */
        _showDropdownLabel:function () {
            if (this.showLabel) {
                if (!this.isListOpen) {
                    this.ui.label.addClass("show-inline");
                    this.ui.button.removeClass("show-inline");
                }
            }
        },

        /**
         * handles a mouse click on the button. this method sets the focus on the button, and toggles the items list (close
         * an open list and opens a close list).
         */
        _handleButtonClick:function () {
            this.ui.button.focus();
            if (this.isListOpen) {
                this.hideItemsList();
            }else {
                this.showItemsList();
            }
        },

        /**
         * on outside click we should close the list
         * @private
         */
        _handleOutsideClick: function() {
            this.hideItemsList();
        },

        /**
         * handles a mouse click on an item. this method sets the focus on the button, selects the clicked item and closes the
         * items list.
         * This is triggered by any itemView.
         *
         * @param clickedItemView used for getting reference to the clicked itemView.
         */
        _handleItemClick:function (clickedItemView) {
            this.ui.button.focus();
            var clickedItemKey = clickedItemView.model.get("key");
            this._setSelection(clickedItemKey);
            this.hideItemsList();
        },

        /**
         * handles a mouse hover on an item.
         * This method marks as active the item from the items list on which the mouse is over and removes the mark
         * from the previous active item.
         * This is triggered by any itemView.
         *
         * @param activeItemView used for getting reference to the hovered itemView.
         */
        _handleItemMouseOver:function (activeItemView) {
            if(!this._inScroll()){
                var activeItemKey = activeItemView.model.get("key");
                this.model.set("activeOption", activeItemKey);
            }
        },

        /**
         * handles keyboard navigation.
         *
         * @param event - used for getting the eventKey
         */
        _handleButtonKeyDown:function (event) {
            var key = (event.keyCode >= CONST_DROPDOWN_NUMPAD_KEYCODE_MIN && event.keyCode <= CONST_DROPDOWN_NUMPAD_KEYCODE_MAX) ? event.keyCode - CONST_DROPDOWN_NUMPAD_KEYCODE_DELTA : event.keyCode;
            var activeOptionKey, activeItemViewElement;

            switch (key) {
                // Esc closes the items list.
                case KeyCode.ESC:
                    this.hideItemsList();
                    break;

                // selects the active item.
                case KeyCode.ENTER:  // enter
                    activeOptionKey = this.model.get("activeOption");
                    if (!_.isNull(activeOptionKey)) {
                        this._setSelection(activeOptionKey);
                    }
                    break;

                case KeyCode.ARROW_DOWN:
                    event.preventDefault();
                    if (!this.isListOpen) {
                        this.showItemsList();
                    }
                    else {
                        activeOptionKey = this.model.get("activeOption");
                        activeItemViewElement = this._getItemViewByKey(activeOptionKey).$el;

                        if (activeItemViewElement.next().length > 0) {
                            var nextItemKey = this._getItemViewByEl(activeItemViewElement.next()).model.get("key");
                            this.model.set("activeOption", nextItemKey);
                            this._scrollDown(1, activeItemViewElement);
                        }
                    }
                    break;

                // up arrow navigates up the list until it reaches the top most item and then it closes the list.
                case KeyCode.ARROW_UP:
                    event.preventDefault();
                    if (this.isListOpen) {
                        activeOptionKey = this.model.get("activeOption");
                        activeItemViewElement = this._getItemViewByKey(activeOptionKey).$el;

                        if (activeItemViewElement.prev().length > 0) {
                            var previousItemKey = this._getItemViewByEl(activeItemViewElement.prev()).model.get("key");
                            this.model.set("activeOption", previousItemKey);
                            this._scrollUp(1, activeItemViewElement);
                        } else {
                            this.hideItemsList();
                        }
                    }
                    break;

                default:
                    if (this.isListOpen) {
                        this.searchController.search(String.fromCharCode(key), _.bind(function(selectedKey){
                            var activeOptionKey = this.model.get("activeOption");
                            this.model.set("activeOption", selectedKey);
                            this._scrollToActiveItem(activeOptionKey, selectedKey);
                        },this));
                    }
            }
        },
        /**
         * calculates the distance from the active element (if any otherwise considers the first element closest
         * to the button) to the selected element and scrolls to it accordingly
         * @param activeKey - active key
         * @param selectedKey - the selected key
         * @private
         */
        _scrollToActiveItem: function(activeKey, selectedKey){
            var firstElement = this.children.findByIndex(0);
            var activeItemViewElement = _.isNull(activeKey) ? firstElement : this._getItemViewByKey(activeKey);
            if (_.isNull(activeItemViewElement)){
                activeItemViewElement = firstElement;
            }
            var scrollIncrement = 5;

            var newItemViewElement = this._getItemViewByKey(selectedKey);
            if (_.isNull(newItemViewElement)){
                return;
            }
            var distance = newItemViewElement.itemIndex - activeItemViewElement.itemIndex;

            if(this.ui.menu.css("top").indexOf("-") === 0){
                distance = distance * -1;
                scrollIncrement = scrollIncrement * 1;
            }
            if(distance < 0){
                this._scrollUp(Math.abs(distance-scrollIncrement), activeItemViewElement.$el);
            }else if(distance > 0){
                this._scrollDown(Math.abs(distance+scrollIncrement), activeItemViewElement.$el);
            }
        },

        _scrollDown:function(distance, itemView){
            var menu = this.ui.menu;
            var pos = menu.height() - (itemView.offset().top - menu.offset().top) - itemView.outerHeight();
            var scroll = pos -(itemView.outerHeight()*distance);
            if (scroll<0) {
                this._animate(menu, -scroll);
            }
        },

        _scrollUp:function(distance, itemView){
            var menu = this.ui.menu;
            var pos = (itemView.offset().top - menu.offset().top);
            var scroll = pos - (itemView.outerHeight()*distance);
            if (scroll<0) {
                this._animate(menu, scroll);
            }
        },

        _animate:function(menu,scroll){
            this.animateRequsetCounter++;
            menu.animate({scrollTop:menu.scrollTop() + scroll}, 0);
            setTimeout(_.bind(function(){
                this.animateRequsetCounter--;
            }, this), 100);
        },

        _inScroll:function(){
            return this.animateRequsetCounter > 0;
        },

        /**
         * When the user is hover the dropdown wrapper we have to show the dropdown button
         * (relevant only if the showLabel property is set to true and there is switch between the button and the label)
         * @private
         */
        _handleWrapperMouseEnter:function () {
            this._showDropdownButton();
        },

        /**
         * When the user is mouse out from the dropdown wrapper we have to show the dropdown label
         * (relevant only if the showLabel property is set to true and there is switch between the button and the label)
         * @private
         */
        _handleWrapperMouseLeave:function () {
            this._showDropdownLabel();
        },

        /**
         * We set the data-hover attribute of the button to true because another method (hideItemsList) needs this indication.
         * There is no native js or jQuery solution to detect if element is hover right now or not on demand so we need a semi-hack for that one.
         * @private
         */
        _handleButtonMouseEnter:function () {
            this.ui.button.data("hover", true);
        },

        /**
         * We set the data-hover attribute of the button to false because another method (hideItemsList) needs this indication.
         * There is no native js or jQuery solution to detect if element is hover right now or not on demand so we need a semi-hack for that one.
         * @private
         */
        _handleButtonMouseLeave:function () {
            this.ui.button.data("hover", false);
        },

        _getItemViewByEl: function(el) {
            var returnedItemView = null;
            _.each(this.children._views, function(itemView) {
                if (itemView.$el[0] === el[0]) {
                    returnedItemView = itemView;
                    return false;
                }
            });
            return returnedItemView;
        },

        _getItemModelByKey:function (itemKey) {
            var itemModel = this.collection.findWhere({"key":itemKey});
            return itemModel;
        },

        _getItemViewByKey:function (itemKey) {
            var itemView = null;
            var itemModel = this._getItemModelByKey(itemKey);
            if (!_.isEmpty(itemModel)) {
                itemView = this.children.findByModel(itemModel);
            }
            return itemView;
        },

        getValue:function () {
            return this.model.get("selectedOption");
        },

        setError:function (isError, errorMsg) {
            if (isError) {
                this.ui.button.addClass("error");
                this.errorMsg = errorMsg;
            }
            else {
                if (typeof this.ui.button === "object" && "removeClass" in this.ui.button) { // TODO (Gal) : There is a case (In entering personView) that we arrive to here when the dropdown is not rendered so this.ui.button is ".dropdown button" and so we do not have removeClass method
                    this.ui.button.removeClass("error");
                    this.errorMsg = null;
                    if (this.uiComponents.DropdownError) {
                        this.uiComponents.DropdownError.close();
                    }
                }
            }
        }
    });

    Dropdown.Collection = DropdownItemsCollection;

    Dropdown.ERROR_POSITION = Bubble.POSITION;

    Dropdown.PERMUTATION = {
        DEFAULT:"default",
        XXX_SMALL1:"xxx-small1",
        XXX_SMALL2:"xxx-small2",
        XXX_SMALL3:"xxx-small3",
        X_SMALL:"x-small",
        X_SMALL1:"x-small1",
        X_SMALL2:"x-small2",
        XX_SMALL1:"xx-small1",
        XX_SMALL2:"xx-small2",
        XX_SMALL_H:"xx-small-h",
        SMALL:"small",
        SMALL1:"small1",
        MID_SMALL_1:"mid-small1",
        MID_SMALL_2:"mid-small2",
        MID_SMALL_3:"mid-small3",
        MID_SMALL_4:"mid-small4",
        MID_SMALL_5:"mid-small5",
        MID_SMALL_6:"mid-small6",
        MEDIUM:"medium",
        MEDIUM2:"medium-2",
        X_LARGE:"x-large",
        X_LARGE2:"x-large-2",
        XX_LARGE:"xx-large",
        XX_LARGE_B:"xx-large-b",
        DRKBG_X_SMALL1_LIGHT: "drkbg-x-small1-light",
        DRKBG_ORANGE: "drkbg-orange",
        DRKBG_NIGHT: "drkbg-night"
    };

    Dropdown.LIST_PERMUTATION = {
        DEFAULT:"default-list",
        BUBBLE_LIST:"bubble-list"
    };

    /**
     * Represents what will be shown in the dropdown button and label
     * @type {Object}
     */
    Dropdown.BUTTON_LABEL = {
        TEXT:"text-only",
        ICON:"icon-only",
        ICON_TEXT:"icon-text"
    };

    Dropdown.TRIGGERING = {
        CHANGE:"change"
    };

    Dropdown.TOOLTIP_POSITION = Tooltip.POSITION;

    var initializers = {
        /**
         * Set all the view members' values - from the options object or defaults.
         * @param options - the "options" object that the component was initialized with
         */
        setViewMembersValues:function (options) {
            this.container = _.has(options, "container") ? options.container : null;
            this.menuMaxHeight = null;
            this.isListOpen = false;
            this.customItem = options.customItem || {};
            this.permutation = options.permutation || Dropdown.PERMUTATION.DEFAULT;
            this.listPermutation = options.listPermutation || Dropdown.LIST_PERMUTATION.DEFAULT;
            this.buttonLabel = options.buttonLabel || Dropdown.BUTTON_LABEL.TEXT;
            this.errorPosition = options.errorPosition || Dropdown.ERROR_POSITION.RIGHT;
            this.showLabel = _.has(options, "showLabel") ? options.showLabel : false;
            this.tabindex = _.has(options, "tabindex") ? options.tabindex : "";
            this.tooltip = _.has(options, "tooltip") ? options.tooltip : "";
            this.tooltipPosition = _.has(options, "tooltipPosition") ? options.tooltipPosition : Dropdown.TOOLTIP_POSITION.BOTTOM;
            this.autofocus = _.has(options, "autofocus") ? options.autofocus : false;
            this.placeholder = _.has(options, "placeholder") ? options.placeholder : null;
            this.collectionMap = _.has(options, "collectionMap") ? options.collectionMap : {};
            this.listenToCollectionChanges = _.has(options, "listenToCollectionChanges") ? options.listenToCollectionChanges : false;
            this.ellipsis =  _.has(options, "ellipsis") ? options.ellipsis : false;
            this.ignoreMaxWidth = _.has(options, "ignoreMaxWidth") ? options.ignoreMaxWidth : false;
            this.maxItemsToShow = _.has(options, "maxItemsToShow") ? options.maxItemsToShow : CONST_DROPDOWN_MAX_ITEMS_SHOWN_IN_MENU;


            // Collision detection properties
            this.collisionWithinSelector = _.has(options, "collisionWithinSelector") ? options.collisionWithinSelector : "window";
            this.testCollision = _.has(options, "testCollision") ? options.testCollision : false;
        },

        /**
         * Set the view model from the options object or defaults.
         * The selectedOption is what we get from the user in the "options" object, or if there isn't placeholder - we select the first item from the list.
         * @param options - the "options" object that the component was initialized with
         */
        setViewModel:function (options) {
            var dropdownModel = new DropdownModel();

            var name = _.has(options, "name") ? options.name : dropdownModel.get("name");
            dropdownModel.set("name", name);

            var items = _.has(options, "items") ? this._getItemsReady(options.items, options.collectionMap) : dropdownModel.get("items");
            dropdownModel.set("items", items);

            var selectedOption;
            if (_.has(options, "selectedOption")) {
                selectedOption = options.selectedOption;
            }
            else {
                if (_.isNull(this.placeholder) && dropdownModel.get("items").size() > 0) {
                    selectedOption = items.at(0).get("key");
                }
                else {
                    selectedOption = dropdownModel.get("selectedOption");
                }
            }
            dropdownModel.set("selectedOption", selectedOption);
            dropdownModel.set("activeOption", selectedOption);

            var enabled = _.has(options, "enabled") ? options.enabled : dropdownModel.get("enabled");
            dropdownModel.set("enabled", enabled);

            this.model = dropdownModel;
        }
    };


    /**
     * Converts the items collection to the DropdownItemsCollection, using the collectionMap.
     * For "key" and "value" - If there are no keys in the map, we are taking the "key" and "value" attributes from the item itself
     * For any other optional property we are checking if there is such property in the map or on the item itself and take it only if exsits
     *
     * @param collection - any Backbone Collection to convert to Dropdown Collection
     * @param collectionMap - The map to convert with
     */
    function convertToDropdownCollection(collection, collectionMap) {
        var dropdownCollection = new DropdownItemsCollection();

        _.each(collection.models, function (model) {
            var dropdownItemModel = convertToDropdownItemModel(model, collectionMap);
            dropdownCollection.add(dropdownItemModel);
        });

        return dropdownCollection;
    }

    /**
     * Converts a model to a dropdownItemModel, using the map
     * For "key" and "value" - If there are no keys in the map, we are taking the "key" and "value" attributes from the item itself
     * For any other optional property we are checking if there is such property in the map or on the item itself and take it only if exsits
     * *
     * @param model
     * @param map
     */
    function convertToDropdownItemModel(model, map) {
        var dropdownItemModel = new DropdownItemModel();
        dropdownItemModel.set("key", getAttributeFromModel("key", model, map));
        dropdownItemModel.set("value", getAttributeFromModel("value", model, map));
        if (_.has(map, "icon") || model.get("icon")) {
            dropdownItemModel.set("icon", getAttributeFromModel("icon", model, map));
        }
        if (_.has(map, "cssClass") || model.get("cssClass")) {
            dropdownItemModel.set("cssClass", getAttributeFromModel("cssClass", model, map));
        }

        return dropdownItemModel;
    }

    /**
     * Get a model with a collection map (or without) and returns the relevant value
     * @param attrName
     * @param model
     * @param collectionMap
     * @return {*}
     */
    function getAttributeFromModel(attrName, model, collectionMap) {
        var attrValue = model.get(getAttributeName(attrName, collectionMap));
        return attrValue;
    }

    /**
     * Get the relevant attribute name according to the collectionMap
     * @param realAttrName
     * @param collectionMap
     */
    function getAttributeName(realAttrName, collectionMap) {
        var attrName = _.has(collectionMap, realAttrName) ? collectionMap[realAttrName] : realAttrName;
        return attrName;
    }

    /**
     *  Calculate an element width - width + padding + border.
     */
    function getElementTotalWidth(elem) {
        var totalWidth = elem.width();
        totalWidth += getPaddingAndBorderWidth(elem);
        return totalWidth;
    }

    function getPaddingAndBorderWidth(elem) {
        var totalWidth = parseInt(elem.css("padding-left"), 10) + parseInt(elem.css("padding-right"), 10); //Total Padding Width
        totalWidth += parseInt(elem.css("borderLeftWidth"), 10) + parseInt(elem.css("borderRightWidth"), 10); //Total Border Width
        return totalWidth;
    }

    return Dropdown;
});
